import FormRegister from './FormRegister';

export default FormRegister;